export const POPI_REQUEST = 'POPI_REQUEST';
export const POPI_SUCCESS = 'POPI_SUCCESS';
export const POPI_FAILURE = 'POPI_FAILURE';
export const SHOW_POPI = 'SHOW_POPI';
export const SHOW_EULA = 'SHOW_EULA';
export const SET_EULA = 'SET_EULA';

export const popiRequest = () => ({
  type: POPI_REQUEST,
});

export const popiSuccess = () => ({
  type: POPI_SUCCESS
});

export const popiFailure = payload => ({
  type: POPI_FAILURE,
  payload,
});

export const showPopi = payload => ({
  type: SHOW_POPI,
  payload,
});
export const showEula= payload => ({
  type: SHOW_EULA,
  payload,
});
export const setEula= payload => ({
  type: SET_EULA,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  showPopi: false,
  showEula:false,
  eula:""
};

export function popiReducer(state = initialState, action) {
  switch (action.type) {
    case SET_EULA:
      return {
        ...state,
        eula: action.payload,
      };
    case SHOW_EULA:
      return {
        ...state,
        showEula: action.payload,
      };
    case SHOW_POPI:
      return {
        ...state,
        showPopi: action.payload,
      };
    case POPI_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case POPI_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false
      };
    case POPI_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
      };
    default:
      return state;
  }
}
